module.exports = __webpack_public_path__ + "media/images/clients/disbursement_success-080e01cb70f49f753cab681e6908e177.svg";